import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Christopher Schreiner
 * id CC30F9D0-3076-4189-A00D-F570D5B0C5D1
 * name book-cross
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-cross.svg
 * tags
 * - Religion 
 */
export const BookCrossIcon = createSvgIcon(<><path d="M5.81,2H7V9L9.5,7.5L12,9V2H18A2,2 0 0,1 20,4V20C20,21.05 19.05,22 18,22H6C4.95,22 4,21.05 4,20V4C4,3 4.83,2.09 5.81,2M13,10V13H10V15H13V20H15V15H18V13H15V10H13Z" /></>, 'BookCrossIcon');
export default BookCrossIcon